<div class="notification-content-wrapper">
  <div class="d-flex justify-content-between">
    <div class="h4 mb-0 text-dark">Tasks</div>
  </div>
  <hr />
  @if (taskProperties.length > 0) {
    <div class="notification-card-wrapper">
      @for (task of taskProperties; track $index) {
        <button
          [id]="'task' + $index"
          class="card notification-card btn-reset"
          (click)="onTaskClick(task)">
          <div class="card-body">
            <div class="row">
              <div class="col-auto">
                <div class="notification-card-icon {{ task.iconBgColor }}">
                  <i class="{{ task.iconColor }} {{ task.icon }}"></i>
                </div>
              </div>
              <div class="col">
                <div>
                  <div class="notification-card-title">{{ task.title }}</div>
                  <div class="notification-card-body">{{ task.body }}</div>
                </div>
              </div>
            </div>
          </div>
        </button>
      }
    </div>
  } @else {
    <div class="text-center">
      <img
        ngSrc="./assets/notifications.svg"
        width="143"
        height="109"
        alt="No Tasks" />
      <div class="h5 mt-3 text-muted">You're all caught up.</div>
      <p class="text-muted">All notifications and actions, will appear here.</p>
    </div>
  }
</div>
